import React from 'react';

import { StyleSheet } from 'react-native';

import { Box, withTypography } from 'components/ui';
import type { BoxProps } from 'components/ui';
import { primitive } from 'styles/constants';

export const AlertContainer = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.alertContainer, style] });

export const AlertText = withTypography({
  variant: 'bodyOne',
  fontSize: 'xs',
  color: primitive.$bbqBrown,
  style: { fontWeight: 'medium' },
});

const styles = StyleSheet.create({
  alertContainer: {
    alignItems: 'center',
    backgroundColor: primitive.$blackOpacity4,
    flexDirection: 'row',
    marginTop: 8,
    paddingHorizontal: 16,
    paddingVertical: 8,
    width: '100%',
  },
});
